import { render, staticRenderFns } from "./StatementList.vue?vue&type=template&id=2fd5b084"
import script from "./StatementList.vue?vue&type=script&lang=js"
export * from "./StatementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports